// extracted by mini-css-extract-plugin
export default {"Icon":"i8zwLQld97k2ftvNaQGK"};